// All action types

const loginLayout = {
  REQUEST_USERDATA: 'REQUEST_USERDATA',
  RECEIVE_USERDATA: 'RECEIVE_USERDATA',
  USER_VALIDITY: 'USER_VALIDITY',
  SERVER_ERROR_OCURED: 'SERVER_ERROR_OCURED',
  LOG_OUT: 'LOG_OUT',
  SHOULD_REDIRECT: 'SHOULD_REDIRECT',
  SHOULD_REDIRECT_LOGIN: 'SHOULD_REDIRECT_LOGIN',
  SEMINAR_UPGRADE_MODAL: 'SEMINAR_UPGRADE_MODAL',
  REQUEST_TOKENVALIDITY: 'REQUEST_TOKENVALIDITY',
  RECEIVE_TOKENVALIDITY: 'RECEIVE_TOKENVALIDITY',
  RECEIVE_LOGIN_STATUS: 'RECEIVE_LOGIN_STATUS'
}

export default loginLayout



// WEBPACK FOOTER //
// ./src/layouts/LoggedIn/actions/actionTypes.js